export { default } from './svg/paint-bucket.svg';
